import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lc-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss']
})
export class ShopComponent implements OnInit {
  public verification_mode: boolean = false;
  public verification_success: boolean = false;
  public verification_error: boolean = false;
  public verification_loading: boolean = false;

  public reset_params: any;
  public activation_code: string;
  public verified_email: string;

  constructor( private route: ActivatedRoute, public dataService: DataService ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
       let uid = params['uid'];
       let email = params['email'];
       let token = params['token'];
       let activation_code = params['code'];

       if(!!email && !!token){
         this.reset_params = {email: email, token: token};
       }
       if(!!activation_code) {
         this.activation_code = activation_code;
       }
       if(!!uid && !!token){
         this.verification_mode = true;
         this.verification_loading = true;
         this.dataService.verify_user(uid, token).subscribe(
         sub_user => {
           this.dataService.subuser_info = sub_user;
           this.dataService.is_verified = true;
           this.dataService.is_logged_in = false;

           this.verification_success = true;
           this.verification_loading = false;
           this.dataService.presentMessage('Uw e-mailadres is gecontroleerd en correct!', 'Success');
           // prefill this email ...
           this.verified_email = this.dataService.subuser_info.email;
         },
         error => {
           this.verification_error = true;
           this.verification_loading = false;
           this.dataService.presentMessage('Sorry! Deze activatielink is niet geldig.', 'Error');
         });
       }
    });
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/shop/shop.component.ts